<div class="dashboard_container_main">
  <ng-container *ngIf="showNewDashboardView">
    <div class="dashboard-header-intro" products-intro-container>
      <div class="dashboard-header-intro-inner" product-intro="nudge">
        <div
          class="dashboard-header-intro-title"
          (click)="redirectToUrl('/master-preview', 'masterPreview')"
        >
          <h1>{{ "phrases.revenue_optimization" | translate }}</h1>
          <img
            src="../../assets/img/nudge_icon.svg"
            style="height: 18px; width: 18px"
          />
        </div>
        <h2
          *ngIf="!nudgeDataFirstLoad"
          [ngClass]="{ blurred_header: nudge_blurred_show }"
        >
          {{ revUplift | currencyFormatter: true }}
        </h2>
        <div
          class="skeleton-fields"
          style="margin: 0; padding-bottom: 5px !important"
          *ngIf="nudgeDataFirstLoad"
        >
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              height: '44px',
              outline: 'none',
              'margin-right': '0px',
              'margin-bottom': '0px',
              'background-color': '#37474f1a',
            }"
          ></ngx-skeleton-loader>
        </div>
        <p>{{ "phrases.revenue_uplift" | translate }}</p>
      </div>
      <div class="dashboard-header-intro-inner" product-intro="diagnostics">
        <div
          class="dashboard-header-intro-title"
          (click)="redirectToUrl('/diagnostic', 'bugTrackingOverall')"
        >
          <h1>{{ "phrases.site_performance" | translate }}</h1>
          <img
            src="../../assets/img/diagnostic_icon.svg"
            style="height: 18px; width: 18px"
          />
        </div>
        <h2
          *ngIf="!diagnosticsDataFirstLoad"
          [ngClass]="{ blurred_header: chartDataBugs_blurred_show }"
        >
          {{ returnLossTotal | currencyFormatter }}
        </h2>
        <div
          class="skeleton-fields"
          style="margin: 0; padding-bottom: 5px !important"
          *ngIf="diagnosticsDataFirstLoad"
        >
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              height: '44px',
              outline: 'none',
              'margin-right': '0px',
              'margin-bottom': '0px',
              'background-color': '#37474f1a',
            }"
          ></ngx-skeleton-loader>
        </div>
        <p>{{ "phrases.total_revenue_loss" | translate }}</p>
      </div>
      <div class="dashboard-header-intro-inner" product-intro="merchandise">
        <div
          class="dashboard-header-intro-title"
          (click)="redirectToUrl('/merchandising', 'merchandising')"
        >
          <h1>{{ "phrases.product_performance" | translate }}</h1>
          <img
            src="../../assets/img/merchandising_icon.svg"
            style="height: 16px; margin-left: 2px; width: 16px"
          />
        </div>
        <h2
          *ngIf="!merchandiseDataFirstLoad"
          [ngClass]="{ blurred_header: merchandiseProducts_blurred_show }"
        >
          {{ unitSold }}
        </h2>
        <div
          class="skeleton-fields"
          style="margin: 0; padding-bottom: 5px !important"
          *ngIf="merchandiseDataFirstLoad"
        >
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              height: '44px',
              outline: 'none',
              'margin-right': '0px',
              'margin-bottom': '0px',
              'background-color': '#37474f1a',
            }"
          ></ngx-skeleton-loader>
        </div>
        <p>{{ "phrases.unit_sold" | translate }}</p>
      </div>
      <div class="dashboard-header-intro-inner" product-intro="organic">
        <div
          class="dashboard-header-intro-title"
          (click)="redirectToUrl(organic_link, 'organic')"
        >
          <h1>{{ "phrases.seo_performance" | translate }}</h1>
          <img
            src="../../assets/img/organic_icon.svg"
            style="height: 19px; width: 19px"
          />
        </div>
        <h2 [ngClass]="{ blurred_header: organicData_blurred_show }">
          {{ organicAllKpis }}
        </h2>
        <p>{{ "phrases.ranking_impact" | translate }}</p>
      </div>
      <div class="dashboard-header-intro-inner" product-intro="automations">
        <div
          class="dashboard-header-intro-title"
          (click)="redirectToUrl('/agents', 'automationsOverview')"
        >
          <h1>{{ "words.agents" | translate }}</h1>
          <img
            src="../../assets/img/automations_icon_1.svg"
            style="height: 19px; width: 19px"
          />
        </div>
        <h2
          *ngIf="!automationsDataFirstLoad"
          [ngClass]="{ blurred_header: automationsPrivilege_blurred_show }"
        >
          {{ automationsRevenue | currencyFormatter }}
        </h2>
        <div
          class="skeleton-fields"
          style="margin: 0; padding-bottom: 5px !important"
          *ngIf="automationsDataFirstLoad"
        >
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              height: '44px',
              outline: 'none',
              'margin-right': '0px',
              'margin-bottom': '0px',
              'background-color': '#37474f1a',
            }"
          ></ngx-skeleton-loader>
        </div>
        <p>{{ "phrases.revenue_uplift" | translate }}</p>
      </div>
      <div
        class="loading-bug-data-overlay"
        *ngIf="
          (!nudgeDataFirstLoad && nudgeDataLoading) ||
          (!diagnosticsDataFirstLoad && diagnosticsDataLoading) ||
          (!merchandiseDataFirstLoad && merchandiseDataLoading) ||
          (!organicDataFirstLoad && organicDataLoading)
        "
      ></div>
    </div>
    <div class="dashboard-products" products-container>
      <div class="dashboard-product-card" product-card="nudge">
        <div class="card-title-container">
          <h1>{{ "phrases.revenue_optimization" | translate }}</h1>
          <div
            class="card-title-container-product"
            [ngClass]="{ disabled: !checkRoleGuard('masterPreview') }"
            (click)="redirectToUrl('/master-preview', 'masterPreview')"
          >
            <img
              src="../../assets/img/nudge_icon.svg"
              style="height: 14px; width: 14px"
            />
            <h1>{{ "words.nudges" | translate }}</h1>
          </div>
        </div>
        <div
          class="card-content"
          *ngIf="!nudgeDataFirstLoad"
          [ngClass]="{ blur_active: nudge_blurred_show }"
        >
          <div class="performance-box-orders_content">
            <ng-container>
              <div class="performance-box-orders_table">
                <div class="performance-box-orders_table-header">
                  <div class="performance-box-orders_table-item width80">
                    <p></p>
                  </div>
                  <div class="performance-box-orders_table-item width120">
                    <p
                      matTooltip="{{
                        'phrases.visits_who_have_seen_at_least_one_nudge'
                          | translate
                      }}"
                      matTooltipPosition="above"
                    >
                      {{ "phrases.nudges_overall" | translate }}
                    </p>
                  </div>
                  <div
                    class="performance-box-orders_table-item width70"
                    *ngIf="!nudgeLite"
                  >
                    <p
                      matTooltip="{{
                        'phrases.visits_who_would_have_seen_at_least_one_nudge_but_were_in_control_control_group_sees_no_nudges_at_all'
                          | translate
                      }}"
                      matTooltipPosition="above"
                    >
                      {{ "words.control" | translate }}
                    </p>
                  </div>
                  <div class="performance-box-orders_table-item">
                    <p *ngIf="!nudgeLite">
                      {{ "phrases.revenue_uplift" | translate }}
                    </p>
                    <p *ngIf="nudgeLite">{{ "words.revenue" | translate }}</p>
                  </div>
                </div>
                <div class="performance-box-orders_table-body">
                  <div class="performance-box-orders_table-row">
                    <div class="performance-box-orders_table-item width80">
                      <p
                        matTooltip="{{
                          'phrases.visit_definition' | translate
                        }}"
                        matTooltipPosition="above"
                      >
                        {{ "words.visits" | translate }}
                      </p>
                    </div>
                    <div class="performance-box-orders_table-item width120">
                      <p *ngIf="this.chartDataCr[0].data[0] == 0.222">0</p>
                      <p *ngIf="this.chartDataCr[0].data[0] != 0.222">
                        {{
                          incentiveBarChart.crorderAmount.incentivesAmount
                            .visits
                        }}
                      </p>
                    </div>
                    <div
                      class="performance-box-orders_table-item width70"
                      *ngIf="!nudgeLite"
                    >
                      <p *ngIf="this.chartDataCr[0].data[0] == 0.222">0</p>
                      <p *ngIf="this.chartDataCr[0].data[0] != 0.222">
                        {{
                          incentiveBarChart.crorderAmount.controlAmount.visits
                        }}
                      </p>
                    </div>
                    <div class="performance-box-orders_table-item">
                      <p
                        [ngClass]="{
                          'uplift-green': revUplift_color === true,
                          'uplift-red': revUplift_color === false,
                          'uplift-none': revUplift_color === 0,
                        }"
                        style="white-space: nowrap"
                      >
                        {{ revUplift | currencyFormatter }}
                      </p>
                    </div>
                  </div>
                  <div class="performance-box-orders_table-row">
                    <div class="performance-box-orders_table-item width80">
                      <p>{{ "words.orders" | translate }}</p>
                    </div>
                    <div class="performance-box-orders_table-item width120">
                      <p *ngIf="this.chartDataCr[0].data[0] == 0.222">0</p>
                      <p *ngIf="this.chartDataCr[0].data[0] != 0.222">
                        {{
                          incentiveBarChart.crorderAmount.incentivesAmount
                            .orders
                        }}
                      </p>
                    </div>
                    <div
                      class="performance-box-orders_table-item width70"
                      *ngIf="!nudgeLite"
                    >
                      <p *ngIf="this.chartDataCr[0].data[0] == 0.222">0</p>
                      <p *ngIf="this.chartDataCr[0].data[0] != 0.222">
                        {{
                          incentiveBarChart.crorderAmount.controlAmount.orders
                        }}
                      </p>
                    </div>
                    <div class="performance-box-orders_table-item">
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <div
            class="pov-bar-charts-holder"
            style="gap: 20px"
            *ngIf="!nudgeLite"
          >
            <!-- [ngClass]="{
              nudgeLite: nudgeLite
            }" -->
            <div class="pov-pageBarChart-container">
              <div class="pov-pageBarChart-axis">
                <h5>{{ "words.cr" | translate }}</h5>
                <div
                  class="pov-pageBarChart-axis-inner"
                  *ngFor="let axis of barChartCrAxis"
                >
                  <p>{{ axis + "%" }}</p>
                </div>
              </div>
              <div class="pov-pageBarChart-main">
                <div
                  class="pov-pageBarChart-main-charts"
                  *ngFor="let bar of barChartCr; let i = index"
                  [ngClass]="{
                    controlBar: bar.control,
                  }"
                >
                  <div class="pov-pageBarChart-main-charts-bar-container">
                    <div
                      class="pov-pageBarChart-main-charts-bar"
                      [ngClass]="{
                        defaultCol: bar.control,
                      }"
                      [ngStyle]="{ height: bar.height + '%' }"
                    >
                      <div
                        [ngClass]="{ zeroBarVal: bar.value == 0 }"
                        class="pov-pageBarChart-main-charts-bar-innervalue"
                      >
                        <div>{{ bar.value + "%" }}</div>
                        <div *ngIf="!bar.control && bar.diff && !nudgeLite">
                          {{ "(" + bar.diff + ")" }}
                        </div>
                      </div>
                      <div
                        class="pov-pageBarChart-main-charts-bar-tooltip"
                        *ngIf="bar.tooltip_translate && !nudgeLite"
                      >
                        <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                        {{
                          "phrases.score_with_label"
                            | translate
                              : {
                                  value: bar.tooltip_translate?.score,
                                  label:
                                    (bar.tooltip_translate?.label | translate),
                                }
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="pov-pageBarChart-main-charts-name">
                    <p>{{ bar.name | translate }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="pov-pageBarChart-container">
              <div class="pov-pageBarChart-axis">
                <h5>{{ "words.rpv" | translate }}</h5>
                <div
                  class="pov-pageBarChart-axis-inner"
                  *ngFor="let axis of barChartRpvAxis"
                >
                  <p>{{ axis | currencyFormatter }}</p>
                </div>
              </div>
              <div class="pov-pageBarChart-main">
                <div
                  class="pov-pageBarChart-main-charts"
                  *ngFor="let bar of barChartRpv; let i = index"
                  [ngClass]="{
                    controlBar: bar.control,
                  }"
                >
                  <div class="pov-pageBarChart-main-charts-bar-container">
                    <div
                      class="pov-pageBarChart-main-charts-bar"
                      [ngClass]="{
                        defaultCol: bar.control,
                      }"
                      [ngStyle]="{ height: bar.height + '%' }"
                    >
                      <div
                        [ngClass]="{ zeroBarVal: bar.value == 0 }"
                        class="pov-pageBarChart-main-charts-bar-innervalue"
                      >
                        {{ bar.value | currencyFormatter }}
                        <div *ngIf="!bar.control && bar.diff && !nudgeLite">
                          {{ "(" + bar.diff + ")" }}
                        </div>
                      </div>

                      <div
                        class="pov-pageBarChart-main-charts-bar-tooltip"
                        *ngIf="bar.tooltip_translate && !nudgeLite"
                      >
                        <b>{{ ("phrases.sig_control" | translate) + ":" }}</b>
                        {{
                          "phrases.score_with_label"
                            | translate
                              : {
                                  value: bar.tooltip_translate?.score,
                                  label:
                                    (bar.tooltip_translate?.label | translate),
                                }
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="pov-pageBarChart-main-charts-name">
                    <p>{{ bar.name | translate }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style="height: 240px; overflow: hidden; margin: auto 0"
            fxFlex="100"
            *ngIf="nudgeLite"
          >
            <div style="height: 240px">
              <google-chart
                class="chart"
                [data]="incentivesLineChart"
                *ngIf="incentivesLineChart && !nudgeDataFirstLoad"
                (window:resize)="onResize($event)"
              >
              </google-chart>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p
            *ngIf="!nudgeDataFirstLoad && !nudge_blurred_show"
            class="view-more-button"
            (click)="redirectToUrl('/master-preview', 'masterPreview')"
          >
            {{ "words.view_more" | translate }}
          </p>
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 16px;
            margin-top: 40px;
          "
          *ngIf="nudgeDataFirstLoad"
        >
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
              height: 65px;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '65px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>

          <div style="display: flex; gap: 20px">
            <div
              class="skeleton-fields"
              style="
                margin: 0 !important;
                padding: 0 !important;
                border-radius: 6px;
                overflow: hidden;
                width: 100%;
                height: 235px;
              "
            >
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  height: '235px',
                  outline: 'none',
                  'margin-right': '0px',
                  'margin-bottom': '0px',
                  'background-color': '#37474f1a',
                }"
              ></ngx-skeleton-loader>
            </div>
            <div
              class="skeleton-fields"
              style="
                width: 100%;
                margin: 0 !important;
                padding: 0 !important;
                border-radius: 6px;
                overflow: hidden;
                height: 235px;
              "
            >
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  height: '235px',
                  outline: 'none',
                  'margin-right': '0px',
                  'margin-bottom': '0px',
                  'background-color': '#37474f1a',
                }"
              ></ngx-skeleton-loader>
            </div>
          </div>
        </div>

        <div
          class="loading-bug-data-overlay"
          *ngIf="!nudgeDataFirstLoad && nudgeDataLoading"
        >
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
      <div class="dashboard-product-card" product-card="diagnostics">
        <div class="card-title-container">
          <h1>{{ "phrases.site_performance" | translate }}</h1>
          <div
            class="card-title-container-product"
            [ngClass]="{ disabled: !checkRoleGuard('bugTrackingOverall') }"
            (click)="redirectToUrl('/diagnostic', 'bugTrackingOverall')"
          >
            <img
              src="../../assets/img/diagnostic_icon.svg"
              style="height: 14px; width: 14px"
            />
            <h1>{{ "sidenav_links.Diagnostic" | translate }}</h1>
          </div>
        </div>
        <div class="card-subtitle-container" *ngIf="!diagnosticsDataFirstLoad">
          <p>{{ "phrases.revenue_loss_reasons" | translate }}</p>
        </div>
        <div
          class="card-content"
          *ngIf="!diagnosticsDataFirstLoad"
          [ngClass]="{ blur_active: chartDataBugs_blurred_show }"
        >
          <div class="hover-unhide" *ngIf="chartDataBugs?.length > 0">
            <div class="chart-main-container">
              <div
                class="chart-item-container"
                *ngFor="let bug of chartDataBugs; let i = index"
                [ngClass]="{ active: i === 0 }"
              >
                <!-- (click)="bugBarChartSelect(bug.type, i)" -->
                <div
                  class="chart-item-title"
                  [ngClass]="{
                    premiumRestricted: bug.type.includes('Premium'),
                  }"
                >
                  <p
                    class="cursor_pointer"
                    (click)="redirectErrorDetailed(bug.bugName, bug.pageName)"
                  >
                    <span
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        flex-wrap: wrap;
                        gap: 4px;
                      "
                    >
                      <span
                        *ngIf="bug.bug_category"
                        class="chart-item-title_pagename pagetype_tag chart-item-title_category"
                      >
                        {{ returnTranslated(bug.bug_category) }}
                      </span>
                      <span
                        *ngIf="bug.type.split(' on ').length == 2"
                        [class]="'chart-item-title_pagename ' + bug.cssClass"
                        [style.background-color]="bug.inlineStyle"
                      >
                        {{ returnTranslated(bug.type.split(" on ")[1]) }}
                      </span>
                    </span>
                    <span
                      class="chart-item-title_bugname"
                      [matTooltip]="
                        chartDataBugs_blurred_show
                          ? ''
                          : bug.type.split(' on ')[0]
                      "
                      matTooltipPosition="above"
                    >
                      {{ bug.type.split(" on ")[0] }}
                    </span>
                  </p>
                </div>
                <div class="chart-item-bar">
                  <div
                    class="chart-item-bar-inner"
                    [ngStyle]="{ width: bug.percentage + '%' }"
                  >
                    <p
                      *ngIf="!showPercentages"
                      class="chart-item-bar-value"
                      [ngClass]="{
                        addResponsive:
                          bug.revenueLoss.length > 8 && bug.percentage > 70,
                        neutral: bug.revenueLoss == 0,
                      }"
                    >
                      {{ bug.revenueLoss | currencyFormatter }}
                    </p>
                    <p
                      *ngIf="showPercentages"
                      class="chart-item-bar-value"
                      [ngClass]="{
                        addResponsive:
                          bug.revenueLoss.length > 8 && bug.percentage > 70,
                        neutral: bug.revenueLoss == 0,
                      }"
                    >
                      {{ bug.TRL_Percentage }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="general-hide-scrollbar"></div>
          </div>

          <div
            style="margin: auto"
            *ngIf="!chartDataBugs || chartDataBugs.length == 0"
          >
            <p>{{ "phrases.no_data_found" | translate }}</p>
          </div>
        </div>
        <div
          class="card-footer"
          *ngIf="
            !diagnosticsDataFirstLoad &&
            chartDataBugs?.length > 0 &&
            !chartDataBugs_blurred_show
          "
        >
          <p
            class="view-more-button"
            (click)="redirectToUrl('/diagnostic', 'bugTrackingOverall')"
          >
            {{ "words.view_more" | translate }}
          </p>
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 16px;
            margin-top: 60px;
          "
          *ngIf="diagnosticsDataFirstLoad"
        >
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>

        <div
          class="loading-bug-data-overlay"
          *ngIf="!diagnosticsDataFirstLoad && diagnosticsDataLoading"
        >
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
      <div class="dashboard-product-card" product-card="merchandise">
        <div class="card-title-container">
          <h1>{{ "phrases.product_performance" | translate }}</h1>
          <div
            class="card-title-container-product"
            [ngClass]="{ disabled: !checkRoleGuard('merchandising') }"
            (click)="redirectToUrl('/merchandising', 'merchandising')"
          >
            <img
              src="../../assets/img/merchandising_icon.svg"
              style="height: 14px; width: 14px"
            />
            <h1>{{ "sidenav_links.Merchandise" | translate }}</h1>
          </div>
        </div>
        <div
          class="card-content"
          *ngIf="!merchandiseDataFirstLoad"
          [ngClass]="{ blur_active: merchandiseProducts_blurred_show }"
        >
          <div class="hover-unhide" *ngIf="merchandiseProducts?.length > 0">
            <div class="custom_table-container dashboard-merch-table">
              <table class="custom_table">
                <thead>
                  <tr>
                    <th class="width50 minWidth20">
                      <div>{{ "words.product" | translate }}</div>
                    </th>
                    <!-- <th class="width50 minWidth80"><div>Id</div></th> -->
                    <th class="width50 minWidth80">
                      <div>{{ "words.revenue" | translate }}</div>
                    </th>
                    <th class="width50 minWidth80">
                      <div>{{ "words.revenue" | translate }} &Delta;</div>
                    </th>
                    <th class="width50 minWidth80">
                      <div>{{ "words.cr" | translate }}</div>
                    </th>
                    <th class="width50 minWidth80">
                      <div>{{ "words.cr" | translate }} &Delta;</div>
                    </th>
                    <th class="width50 minWidth20">
                      <div>{{ "phrases.units_sold" | translate }}</div>
                    </th>
                    <th class="width50 minWidth80">
                      <div>
                        {{ "words.price" | translate }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let product of merchandiseProducts">
                    <tr>
                      <td>
                        <div class="dashboard-merchandise-image">
                          <img
                            [src]="product?.sanitized_url"
                            alt="Product Image"
                          />
                        </div>
                      </td>
                      <td>
                        {{ product?.total_revenue | currencyFormatter }}
                      </td>
                      <td>
                        <div
                          [ngClass]="{
                            negative: product?.total_revenue_diff < 0,
                            positive: product?.total_revenue_diff >= 0,
                          }"
                        >
                          {{ product?.total_revenue_diff_formatted }}%
                        </div>
                      </td>
                      <td>
                        <div
                          [ngClass]="{
                            negative: product?.conversion_rate < 0,
                            positive: product?.conversion_rate >= 0,
                          }"
                        >
                          {{ product?.conversion_rate_formatted }}%
                        </div>
                      </td>
                      <td>
                        <div
                          [ngClass]="{
                            negative: product?.conversion_rate_diff < 0,
                            positive: product?.conversion_rate_diff >= 0,
                          }"
                        >
                          {{ product?.conversion_rate_diff_formatted }}%
                        </div>
                      </td>
                      <td>
                        {{ product?.total_units_sold_formatted }}
                      </td>
                      <td>
                        {{ product?.price | currencyFormatter }}
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div class="general-hide-scrollbar"></div>
          </div>
          <div
            style="margin: auto"
            *ngIf="!merchandiseProducts || merchandiseProducts?.length == 0"
          >
            <p>{{ "phrases.no_data_found" | translate }}</p>
          </div>
        </div>
        <div
          class="card-footer"
          *ngIf="
            !merchandiseDataFirstLoad &&
            merchandiseProducts?.length > 0 &&
            !merchandiseProducts_blurred_show
          "
        >
          <p
            class="view-more-button"
            (click)="redirectToUrl('/merchandising', 'merchandising')"
          >
            {{ "words.view_more" | translate }}
          </p>
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 16px;
            margin-top: 60px;
          "
          *ngIf="merchandiseDataFirstLoad"
        >
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>

        <div
          class="loading-bug-data-overlay"
          *ngIf="!merchandiseDataFirstLoad && merchandiseDataLoading"
        >
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
      <div class="dashboard-product-card" product-card="organic">
        <div class="card-title-container">
          <h1>{{ "phrases.seo_performance" | translate }}</h1>
          <div
            class="card-title-container-product"
            [ngClass]="{ disabled: !organic_role }"
            (click)="redirectToUrl(organic_link, 'organic')"
          >
            <img
              src="../../assets/img/organic_icon.svg"
              style="height: 14px; width: 14px"
            />
            <h1>{{ "sidenav_links.Organic" | translate }}</h1>
          </div>
        </div>
        <div class="card-subtitle-container" *ngIf="!organicDataFirstLoad">
          <p>{{ "phrases.main_issues_impacting_seo" | translate }}</p>
        </div>
        <div
          class="card-content"
          *ngIf="!organicDataFirstLoad"
          [ngClass]="{ blur_active: organicData_blurred_show }"
        >
          <div
            class="ai_analysis-custom-barchart-dataholder"
            style="margin-top: 5px"
            *ngIf="organicData?.length > 0"
          >
            <div class="ai_analysis_gr_table">
              <div class="ai_analysis_gr_table_header">
                <div class="ai_analysis_gr_table_grp1">
                  <h3>{{ "words.factor" | translate }}</h3>
                </div>
                <div class="ai_analysis_gr_table_grp2">
                  <h3>{{ "words.keywords" | translate }}</h3>
                </div>
                <div class="ai_analysis_gr_table_grp3">
                  <h3>{{ "words.ranking_impact" | translate }}</h3>
                </div>
              </div>
              <div class="ai_analysis_gr_table_content_scroll">
                <div
                  class="ai_analysis_gr_table_content"
                  *ngFor="let chartData of organicData; let i = index"
                >
                  <div class="ai_analysis_gr_table_grp1">
                    <h1>
                      {{ chartData.tmp_renamed_name }}
                    </h1>
                  </div>
                  <div
                    class="ai_analysis_gr_table_grp2"
                    style="padding-left: 5px; box-sizing: border-box"
                  >
                    <span>{{ chartData.variable_labels }}</span>
                  </div>
                  <div
                    class="ai_analysis_gr_table_grp3"
                    style="padding-left: 5px; box-sizing: border-box"
                  >
                    <div
                      class="percentage"
                      [ngClass]="{
                        positive: chartData?.value > 0,
                        negative: chartData?.value < 0,
                        neutral: chartData?.value == 0,
                      }"
                    >
                      {{ chartData.formatted_value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            style="margin: auto"
            *ngIf="!organicData || organicData?.length == 0"
          >
            <p>{{ "phrases.no_data_found" | translate }}</p>
          </div>
        </div>
        <div
          class="card-footer"
          *ngIf="
            !organicDataFirstLoad &&
            organicData?.length > 0 &&
            !organicData_blurred_show
          "
        >
          <p
            class="view-more-button"
            (click)="redirectToUrl(organic_link, 'organic')"
          >
            {{ "words.view_more" | translate }}
          </p>
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 16px;
            margin-top: 60px;
          "
          *ngIf="organicDataFirstLoad"
        >
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div
            class="skeleton-fields"
            style="
              margin: 0 !important;
              padding: 0 !important;
              border-radius: 6px;
              overflow: hidden;
            "
          >
            <ngx-skeleton-loader
              count="1"
              [theme]="{
                height: '48px',
                outline: 'none',
                'margin-right': '0px',
                'margin-bottom': '0px',
                'background-color': '#37474f1a',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>

        <div
          class="loading-bug-data-overlay"
          *ngIf="!organicDataFirstLoad && organicDataLoading"
        >
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!showNewDashboardView">
    <!-- Performance Bars -->
    <app-performance></app-performance>
    <!-- Frequencies -->
    <app-nudges></app-nudges>
  </ng-container>
</div>
